import FollowAttention from '@/components/feature/FollowAttention';
import ReadNotice from '@/components/feature/ReadNotice';
import { useReadResource } from '@/hooks/useReadResource';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeHeader from './components/HomeHeader';
import MarketWatchlist from './components/MarketWatchlist';
import AccountSummaryCard from './components/AccountSummaryCard';
import SystemStatusBanner from './components/SystemStatusBanner';
import MT4StatusCard from './components/MT4StatusCard';
import GuestHome from './components/GuestHome';
import { useAuth } from '@/contexts/AuthContext';
import { forexApi, toBrokerAccount, toFollowRecord } from '@/services/forexApi';

export default function HomePage() {
  const { user, accessToken, loading: authLoading, authError } = useAuth();
  const navigate = useNavigate();
  const identity = accessToken || '';
  const enabled = !!user && !!accessToken;
  const accounts = useReadResource(identity, useCallback(() => forexApi.listFollowerAccounts(accessToken), [accessToken]), enabled);
  const relations = useReadResource(identity, useCallback(() => forexApi.listFollowRelations(accessToken), [accessToken]), enabled);
  const performance = useReadResource(identity, useCallback(() => forexApi.getFollowPerformanceSummary(accessToken), [accessToken]), enabled);
  const decisions = useReadResource(identity, useCallback(() => forexApi.listAiDecisions(accessToken, 1, 1), [accessToken]), enabled);
  const notifications = useReadResource(identity, useCallback(() => forexApi.getNotificationSummary(accessToken), [accessToken]), enabled);
  const reads = [accounts, relations, performance, decisions, notifications];
  const follows = relations.data?.map(relation => toFollowRecord(relation, []));
  const running = follows?.filter(relation => relation.followStatus === 'running').length ?? null;
  const paused = follows?.filter(relation => ['paused_by_user', 'paused_by_platform'].includes(relation.followStatus)).length ?? null;
  return <div className="min-h-screen" style={{ background: '#F7F8FC', paddingBottom: '84px' }}>
    {authLoading ? <div className="m-5 h-48 animate-pulse rounded-2xl bg-white" /> : !user ? <GuestHome onLogin={() => navigate('/auth?redirect=%2F')} /> : <>
      {authError && <p role="alert" className="p-4 text-amber-700">{authError}</p>}
      <HomeHeader notificationCount={notifications.data?.unread ?? null} onNotificationClick={() => navigate('/notifications')} />
      <FollowAttention />
      <AccountSummaryCard runningFollows={running} pausedFollows={paused}
        connectedAccounts={accounts.data?.map(toBrokerAccount).filter(account => account.accountStatus === 'connected').length ?? null}
        pendingAlerts={notifications.data?.unread ?? null} recentDecisions={decisions.data?.total ?? null}
        weekPnl={performance.data?.total_pnl ?? null} pnlCurrency={performance.data?.pnl_currency ?? null} />
      <div className="px-5 mt-3 space-y-2">
        {reads.map((read, index) => <ReadNotice key={index} {...read} label={['账户', '跟随', '收益', '决策', '消息'][index]} onRetry={read.refresh} />)}
        <button className="text-xs text-indigo-600" onClick={() => reads.forEach(read => { void read.refresh(); })}>刷新概览</button>
      </div>
      <MT4StatusCard />
      <SystemStatusBanner loading={reads.some(read => read.loading)} failed={reads.some(read => !!read.error)} />
      <MarketWatchlist />
    </>}
  </div>;
}
